import React from 'react'
import PageTransition from 'gatsby-plugin-page-transitions'

import { ProductList, Title, Submenu } from '../../components'
import { brojila } from '../../productInfo'
import { greenRectangleStyle } from '../../rectangleStyles'

import './index.css'

const ProizvodiPage = () => (
  <PageTransition>
    <div className="products-title-container">
      <div className="container">
        <Title rectangleStyle={greenRectangleStyle}>Brojila</Title>
      </div>
    </div>
    <div className="products-accordion">
      <ProductList products={brojila} />
    </div>
  </PageTransition>
)

export default ProizvodiPage



// WEBPACK FOOTER //
// ./src/pages/proizvodi/index.js